import React from "react";
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterTweetEmbed,
} from "react-twitter-embed";
import './tweets.css'

function TweetsBox() {
  return (
    <div className="box">
        <h2>World Health Organization tweets</h2>
        <br/>
        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="WHO"
          options={{ height: 600 }}
        />
    </div>
  );
}

export default TweetsBox;